// Author: Luis Booth - November 2018 (no necesariamente).

import React, { Component } from 'react';
import validationEngine from 'js/modules/validationEngine';
import DataService from 'js/modules/dataservice';
import moment from 'moment';
import cm from 'js/modules/cm';

const ConfirmationContext = React.createContext();

const validationRules = {
  weddingAnniversary: [],
  foodAlergyRestriction: [],
  earlyCheckIn: [],
  birthdayGuestName: [],
  birthday: [],
  rollAway: [],
  disabledGuest: [],
  honeymoon: [],
  closerBookingNumber: [],
  specialRequest: [],
  bookingNumber: [],
};

const isSandals = window._app.brandOptions.isSandals;

class ConfirmationProvider extends Component {
  constructor(props) {

    super(props);

    this.confirmationRef = React.createRef();
  }

  state = {
    fields: {
      cardType: 'VS',
      weddingAnniversary: '',
      foodAlergyRestriction: false,
      earlyCheckIn: false,
      birthdayGuestName: '',
      birthday: '',
      rollAway: false,
      disabledGuest: false,
      honeymoon: false,
      closerBookingNumber: '',
      specialRequest: '',
      bookingNumber: '',
    },
    summaryResponse: {},
    summaryLoaded: false,
    guests: [],
    oeeParams: {
      starDate: '',
      endDate: '',
      noOfAdults: '',
      noOfChildren: '',
      nights: '',
      eventID: '',
      groupID: '',
      check_in_date: '',
      resortCode: '',
      brand: '',
      resort: '',
      reference: 'oee',
    },
    oeeURL: window._app.brandOptions.oeeURL,
    brandName: window._app.brandOptions.longName,
    warning: false,
    showLoader: false,
    resortURI: '',
    fieldValidations: {},
    response: {
      code: -1,
      message: '',
    },
    isActive: false,
    gateways: {},
  };

  async componentDidMount() {
    const fields = {...this.state.fields};
    const summaryResponse = await DataService.readSummary();
    const gatewaysResponse = await DataService.readGateways();

    if (summaryResponse.code === 1) {
      fields.bookingNumber = summaryResponse.content.bookingNumber;
      this.setState({
        summaryResponse: summaryResponse.content,
        summaryLoaded: true,
        resortURI: summaryResponse.content.resortInfo.resortURI,
        fields
      });
    }

    // Refactor after Willmer's change to dataservice method
    if (gatewaysResponse.code === 1) {
      const gateways = {};

      for(const item of gatewaysResponse.content) {
        gateways[item.gateway.toLowerCase()] = {
          city: item.city.toLowerCase(),
          airportName: item.airportName,
          gateway: item.gateway.toLowerCase(),
        };
      }

      this.setState({ gateways });
    }

    this._populateGuestsNames(summaryResponse.content.guestsData);
    this._populateOEEParams(summaryResponse.content);
    this.setDefaultValuesValidation();
    cm.cmCreateShopAction9Tag(summaryResponse.content);
    cm.cmCreateOrderTag(summaryResponse.content);
    cm.cmCreateRegistrationTag(summaryResponse.content);
    cm.cmDisplayShops();
  }

  setDefaultValuesValidation = () => {
    const fieldsRules = validationRules;
    const namedFields = Object.keys(fieldsRules);
    let fieldValidations = { ... this.state.fieldValidations };

    fieldValidations = {};

    namedFields.map((field) => {
      fieldValidations[field] = true;
    });

    this.setState({fieldValidations});
  }

  _populateGuestsNames = (guestsData) => {
    const { firstName, lastName, id } = guestsData;
    const guests = [...this.state.guests];

    // fill data primary guest.
    guests.push({
      label: `${firstName} ${lastName}`,
      value: `${id}`,
    });

    guestsData.secondaryGuests.map((guest) => {
      guests.push({
        label: `${guest.firstName} ${guest.lastName}`,
        value: `${guest.id}`,
      });
    });

    this.setState({ guests });
  }

  _populateOEEParams = (bookingData) => {
    let oeeParams = {...this.state.oeeParams};
    const { brandName } = this.state;
    const {
      checkInDate,
      checkOutDate,
      adults,
      children,
      rstCode,
    } = bookingData.vacationData;

    const { resortShortName } = bookingData.resortInfo;

    const { webConfirmationNumber = '', group = {} } = bookingData;
    const { groupId = '' } = group;

    const startDate = moment(bookingData.vacationData.checkInDate);
    const endDate = moment(bookingData.vacationData.checkOutDate);
    const nights = endDate.diff(startDate, 'days');

    oeeParams = {
      startDate: checkInDate,
      endDate: checkOutDate,
      noOfAdults: adults,
      noOfChildren: children,
      nights: nights,
      eventID: '',
      groupID: groupId,
      check_in_date: checkInDate,
      resortCode: rstCode,
      brand: brandName,
      resort: resortShortName,
      reference: 'oee',
    };

    if (brandName === 'beaches') {
      oeeParams.notOeeRequest = true;
      oeeParams.confirmation_number = webConfirmationNumber;
    }

    this.setState({ oeeParams });
    this._buildOEEUrl(oeeParams);
  }

  _buildOEEUrl = (oeeParams) => {
    const { oeeURL } = this.state;
    const parameters = Object.keys(oeeParams);
    let oeeURLUpdate = oeeURL;

    //  /book-now/ is a Website action that redirects to the OEE. If the website changes that OBE has too.
    oeeURLUpdate = `${window._app.brandOptions.url}/book-now/?`;

    parameters.map(param => {
      let paramValue = oeeParams[param];

      if (param.includes('Date')) {
        paramValue = moment(paramValue).format('MM/DD/YYYY');
        paramValue = paramValue.replace(/-/g, '/');
      }

      oeeURLUpdate += `&${param}=${encodeURIComponent(paramValue)}`;
    });

    this.setState({oeeURL: isSandals ? oeeURLUpdate : oeeURL});
  }

  _updateFields = (newFields) => {

    const { ...oldFields } = this.state.fields;
    const fields = { ...oldFields, ...newFields };
    let { warning } = this.state;

    warning = false;

    this.setState({ fields, warning });
  }

  _updateFieldValidations = (newFields) => {

    const { ...oldFields } = this.state.fieldValidations;
    const fieldValidations = { ...oldFields, ...newFields };

    this.setState({ fieldValidations });
  }

  updateResponse = (resp = {}) => {
    let response = {...this.state.response};
    let { isActive } = this.state;

    // -1 means toggle, 1 Success and 0 fail.
    response = resp;
    isActive = !isActive;

    this.setState({response, isActive});
  }

  setInputValue = (value, name) => {

    const fieldValidation = validationEngine.runValidations(validationRules, value, name);

    this._updateFieldValidations({[name]: fieldValidation.allValid});

    if (name === 'birthdayGuestName') {
      this._updateFields({
        birthday: '',
        [name]: value
      });
    } else {
      this._updateFields({[name]: value});
    }

  }

  setMultipleInputValues = (values = [], names = []) => {

    const fieldValidations = { ... this.state.fieldValidations };
    const newFields = {};

    names.map((name, index) => {
      newFields[name] = values[index];
      fieldValidations[name] = true;
    });

    this.setState({ fieldValidations });
    this._updateFields(newFields);
  }

  setDateValue = (value, name) => {

    const fieldValidation = validationEngine.runValidations(validationRules, [value], [name]);

    this._updateFieldValidations({[name]: fieldValidation.allValid });
    this._updateFields({[name]: value});
  }

  getFields = () => { return {...this.state.fields}; }

  toggleForm = () => {
    const response = {...this.state.response};
    let { isActive } = this.state;

    // -1 means toggle, 1 Success and 0 fail.
    response.code = -1;
    isActive = !isActive;

    this.setState({response, isActive});
  }

  toggleRequired = (fieldNameArray = []) => {
    const required = 'required';

    return () => {
      fieldNameArray.map(fieldName => {
        const [...validationArray] = validationRules[fieldName];
        const indexOfRequired = validationArray.indexOf(required);

        if (indexOfRequired > -1) {
          validationArray.splice(indexOfRequired, 1);
        } else {
          validationArray.push(required);
        }

        validationRules[fieldName] = validationArray;
      });
    };
  }

  onSubmit = () => {
    const fields = {...this.state.fields};
    const fieldValidations = { ... this.state.fieldValidations };
    const inputNames = Object.keys(fields);
    let noErrors = 0;
    let { warning } = this.state;

    // Re run validations to be sure that everything is ok.
    inputNames.map((inputName) => {

      const fieldValue = fields[inputName] === undefined ? '' : fields[inputName];
      const fieldValidation = validationEngine.runValidations(validationRules, fieldValue, inputName);

      this._updateFieldValidations({[inputName]: fieldValidation.allValid});

      // Setting up styles in invalid fields and error counting.
      if (fieldValidation.allValid === false) {
        if (noErrors === 0) { this._onErrorScroll(); }
        warning = true;
        noErrors++;
        fieldValidations[inputName] = false;
      }
    });

    this.setState({ fieldValidations, warning });

    return noErrors;
  }

  toggleLoader = (value) => {
    this.setState({ showLoader: value });
  }

  _onErrorScroll = () => {

    const element = this.confirmationRef.current;

    element.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    const context = {
      state: this.state,
      setInputValue: this.setInputValue,
      setMultipleInputValues: this.setMultipleInputValues,
      updateResponse: this.updateResponse,
      setDateValue: this.setDateValue,
      getFields: this.getFields,
      toggleRequired: this.toggleRequired,
      toggleForm: this.toggleForm,
      toggleLoader: this.toggleLoader,
      onSubmit: this.onSubmit,
      confirmationRef: this.confirmationRef,
    };

    return (
      <ConfirmationContext.Provider value={context}>
        {this.props.children}
      </ConfirmationContext.Provider>
    );
  }
}

export { ConfirmationContext, ConfirmationProvider };



// WEBPACK FOOTER //
// ./js/components/step5/confirmation/ConfirmationContext.js